import { useState } from 'react'

import { steps } from '@/RefundSelectionPage/BankAccountDrawer/constants'

const useManageSteps = ({ onClose }) => {
  const [step, setStep] = useState(steps.bankAccountStep)

  const getShowBack = () => {
    if (step === steps.bankAccountStep) return false

    if (step === steps.verifyAccountStep) return true

    return false
  }

  const handleOnClose = () => {
    setStep(steps.bankAccountStep)
    onClose()
  }

  const onBack = () => {
    const backByStep = {
      [steps.verifyAccountStep]: steps.bankAccountStep,
    }

    setStep(backByStep[step])
  }

  return {
    step,
    setStep,
    handleOnClose,
    showBack: getShowBack(),
    onBack,
  }
}

export default useManageSteps
